<template>
  <div class="row">
    <div class="col-md-3">
      <div v-if="giftCard.image_url" class="item-image">
        <img :src="giftCard.image_url" class="img-fluid">
      </div>

      <div v-else class="text-center">
        <i class="fa fa-picture-o" style="font-size: 10em;" aria-hidden="true"></i>
      </div>
    </div>

    <div class="col-md-9">
      <a v-if="disableShowButton" href="javascript:;" class="btn btn-primary float-right">
        Show Gift Card
      </a>
      <router-link v-else :to="{name: 'giftCardShow',
        params: { gift_card: giftCard, id: giftCard.id, gift_card_title: giftCard.title.replace(/ /g, '-') }}"
        class="btn btn-primary float-right">
        Show Gift Card
      </router-link>

      <h3 class="item-title">
        <i class="fa fa-gift" aria-hidden="true"></i>
        {{ giftCard.title }}
      </h3>

      <div class="item-actions">
        Tickets <strong> <i class="fa fa-ticket"></i> {{ giftCard.ticket_quantity }} </strong>
      </div>
      <div class="item-actions">
        Price <span><strong> {{ giftCard.formatted_price_with_fee }} </strong></span>
      </div>
      <div class="item-description" v-html="markedText(giftCard.description)">
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GiftCardRow',
  props: {
    giftCard: {
      required: true,
      type: Object
    },
    disableShowButton: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function () {
    return { }
  }
}
</script>
